import axios from "axios";
import config from "@/config/env.config.json";
import logger from "@/utils/logger";

const envConfig = config[process.env.NODE_ENV];
const consumerBaseUrl = envConfig.consumerApiBaseUrl;
const specialtyApi = {};

specialtyApi.getSpecialties = async () => {
  try {
    const url = `${consumerBaseUrl}/practice_specialties`;
    console.log("API REQUEST", "GET", url);
    const response = await axios.get(url);
    console.log("API RESPONSE", "GET", url, response.status, response.data);
    logger.info("specialties api", response.data);
    return response.data;
  } catch (error) {
    console.error("API ERROR", "GET", "getSpecialties", error);
    logger.error(error);
    throw error;
  }
};

export default specialtyApi;
